import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import DomesticInternationalToursDetails from "../components/DomesticnternationalToursDetails";

const DomesticInternationalTours = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Domestic & International Tours"} />

      {/* Service Details Area */}
      <DomesticInternationalToursDetails />
      


      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default DomesticInternationalTours;
